__turbopack_context__.v({
  "button": "plain-module-scss-module__ldR8GW__button" + " " + __turbopack_context__.i(693367)["core"],
  "complete": "plain-module-scss-module__ldR8GW__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "plain-module-scss-module__ldR8GW__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "plain-module-scss-module__ldR8GW__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "plain-module-scss-module__ldR8GW__small" + " " + __turbopack_context__.i(693367)["small"],
});
